import { IAppConfig } from './types';

function loadStaticModules(appConfig: IAppConfig) {
  require('D:/Code/fpx-giws-web/node_modules/build-plugin-ice-request/lib/runtime.js').default(
    { appConfig }
  );
}

export default loadStaticModules;
